import React from 'react'
import Card from '../components/Card'

export default function About() {
  return (
    <div className="container">
      <section className="card">
        <h2 className="h2">About 1OPSS</h2>
        <p className="kv">We connect small businesses and individuals with vetted bookkeepers. Our mission is to make bookkeeping simple, secure, and affordable.</p>

        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginTop:12}}>
          <Card className="center"><div style={{fontWeight:700}}>Vetted pros</div><div className="kv">All bookkeepers pass a credential check.</div></Card>
          <Card className="center"><div style={{fontWeight:700}}>Secure</div><div className="kv">Data encryption & secure file storage.</div></Card>
          <Card className="center"><div style={{fontWeight:700}}>Easy hiring</div><div className="kv">Match & start in a few clicks.</div></Card>
        </div>
      </section>
    </div>
  )
}
